export const US_PHONE_CODE = '+1';
export const PHONE_FIELD_PLACEHOLDER = `${US_PHONE_CODE} (212) 000-0000`;
export const EMAIL_FIELD_PLACEHOLDER = 'example@domain.com';
